// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".worker_schema_row{display:flex;flex-wrap:wrap;margin-bottom:20px !important}.worker_schema_row>div:first-child{flex-basis:100%}.worker_schema_row>div:nth-child(n+2):nth-last-child(-n+2){flex-basis:calc(50% - 10px);margin-right:10px}", ""]);
// Exports
module.exports = exports;
